import { Button, makeStyles } from '@material-ui/core';
import React from 'react';

const IdeasIcon = (): React.ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" viewBox="0 0 15 20" fill="none">
    <path d="M6.0875 19.4125C5.69583 19.0208 5.5 18.55 5.5 18H9.5C9.5 18.55 9.30417 19.0208 8.9125 19.4125C8.52083 19.8042 8.05 20 7.5 20C6.95 20 6.47917 19.8042 6.0875 19.4125ZM3.5 17V15H11.5V17H3.5ZM3.75 14C2.6 13.3167 1.6875 12.4 1.0125 11.25C0.3375 10.1 0 8.85 0 7.5C0 5.41667 0.729167 3.64583 2.1875 2.1875C3.64583 0.729167 5.41667 0 7.5 0C9.58333 0 11.3542 0.729167 12.8125 2.1875C14.2708 3.64583 15 5.41667 15 7.5C15 8.85 14.6625 10.1 13.9875 11.25C13.3125 12.4 12.4 13.3167 11.25 14H3.75Z" fill="black"/>
  </svg>
);

export const useStyles = makeStyles({
  root: {
    paddingRight: '21px',
    textTransform: 'capitalize',
  },
  startIcon: {
    marginRight: '6px',
  },
});

export default function IdeasButton(): React.ReactElement {
  const classes: any = useStyles();

  return (
    <Button
      size="small"
      className={classes.root}
      classes={{ startIcon: classes.startIcon }}
      component="a"
      href="https://targetcrm.ideas.aha.io/"
      target="_blank"
      rel="noopener noreferrer"
      startIcon={<IdeasIcon />}>
      Ideas Portal
    </Button>
  );
}
